import { render, staticRenderFns } from "./LoggedIntoOtherApp.vue?vue&type=template&id=32f652bd&scoped=true"
import script from "./LoggedIntoOtherApp.vue?vue&type=script&lang=js"
export * from "./LoggedIntoOtherApp.vue?vue&type=script&lang=js"
import style0 from "./LoggedIntoOtherApp.vue?vue&type=style&index=0&id=32f652bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f652bd",
  null
  
)

export default component.exports